<template>
  <div class="wrapper-content">
    <div class="wrapper-left">
      <el-tree
        :data="departmentData"
        show-checkbox
        node-key="id"
        ref="tree"
        highlight-current
        :check-strictly="true"
        @check="checkChange"
        :props="defaultProps"
        :default-expanded-keys="[editCheckId]"
      >
      </el-tree>
    </div>
    <div class="wrapper-right">
      <transition name="fade">
        <div class="no-data" v-if="editCheckId === ''"><i class="icon-font">&#xe6be;</i>请选择公司或部门</div>
      </transition>
      <transition name="enter-fade">
        <div class="wrapper-right-content" v-if="editCheckId !== ''">
          <div class="wrapper-right-operation" style="padding-top: 0;padding-bottom: 1vw;border-bottom: dashed 0.1vw #3b79a1">
            <div class="wrapper-right-operation-list">
              <div class="four-font-wrapper margin-right" @click="showAddModal(1)"><div class="icon-font">&#xe605;</div>添加用户</div>
              <div class="four-font-wrapper" @click="deleteAll"><div class="icon-font">&#xe646;</div>批量删除</div>
            </div>
            <div class="wrapper-right-operation-list">
              <div class="input-wrapper" style="margin-right: 1vw">
                <input placeholder="请输入关键字" v-model="search.value"/>
              </div>
              <div class="query button" @click="handleSearch(true)">查询</div>
            </div>
          </div>
          <div class="detail">
            <div class="detail-box">
              <div class="detail-nav">
                <div class="detail-item" style="width: 8%">
                  <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
                </div>
                <div class="detail-item" style="width: 10%">账号</div>
                <div class="detail-item" style="width: 10%">姓名</div>
                <div class="detail-item" style="width: 8%">性别</div>
                <div class="detail-item" style="width: 19%">角色</div>
                <div class="detail-item" style="width: 10%">所属部门</div>
                <div class="detail-item" style="width: 10%">状态</div>
                <div class="detail-item" style="width: 25%">操作</div>
              </div>
              <div class="detail-content" v-if="!loading">
                <div class="detail-list-wrapper" v-for="(data,index) in tableData" :key="index">
                  <div class="detail-item" style="width: 8%" >
                    <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>
                  </div>
                  <div class="detail-item" style="width: 10%">{{data.account}}</div>
                  <div class="detail-item" style="width: 10%">{{data.name}}</div>
                  <div class="detail-item" style="width: 8%">{{data.sex === 1 ? '男' : '女'}}</div>
                  <div class="detail-item" style="width: 19%">{{data.roleName || '--'}}</div>
                  <div class="detail-item" style="width: 10%">{{data.deptName || '--'}}</div>
                  <div class="detail-item" style="width: 10%" :class="{'color-red': data.status === 2}">{{data.status === 1 ? '启用' : '禁用'}}</div>
                  <div class="detail-item" style="width: 25%;flex-direction: column">
                    <div>
                      <div class="detail-btn item-look" style="margin-right: 0.5vw" @click="showAddModal(2, data)">修改</div>
                      <div class="detail-btn item-history" style="margin-right: 0.5vw" @click="data.status === 1 ? freezeUser(data.id) : unFreezeUser(data.id)" :class="{'item-apply': data.status === 2}">{{data.status === 1 ? '冻结用户' : '解除冻结'}}</div>
                      <div class="detail-btn item-set" @click="showAddModal(4, data)">修改密码</div>
                    </div>
                    <div style="margin-top: 0.5vw">
                      <div class="detail-btn item-delete" style="margin-right: 0.5vw" @click="deleteSingle(data.id)">删除</div>
                      <div class="detail-btn item-audit" style="margin-right: 0.5vw" @click="showAddModal(3, data)">角色分配</div>
                      <div class="detail-btn item-audit-active" @click="resetPassword(data.id)">重置密码</div>
                    </div>
                  </div>
                </div>
                <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
              </div>
              <div class="page-wrapper" v-if="!loading && total > rows">
                <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
                <div class="page-wrapper-right">
                  <div class="page-btn" @click="firstPage">首页</div>
                  <div class="page-btn" @click="previousPage">上一页</div>
                  <div class="page-btn" @click="nextPage">下一页</div>
                  <div class="page-btn" @click="lastPage">尾页</div>
                </div>
              </div>
              <div class="loading-data" v-if="loading">
                <i class="el-icon-loading"></i>
                <div>加载中，请稍后···</div>
              </div>
            </div>
            <transition name="fade">
              <div class="alert-box" v-if="show">
                <div class="alert-content">
                  <div class="alert-content-title">{{type === 1 || type === 0? '删除提醒' : type === 2 ? '冻结提醒' : type === 3 ? '解除冻结提醒' : '重置密码提醒'}}</div>
                  <div class="alert-content-msg">是否确认{{type === 1 || type === 0 ? '删除' : type === 2 ? '冻结' : type === 3 ?  '解除冻结' : '重置'}}选中数据?</div>
                  <div class="alert-content-btn">
                    <div class="btn-cancel button" @click="cancelDelete">取消</div>
                    <div class="btn-confirm button" @click="confirmDelete">确认</div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <transition name="fade">
            <div class="alert-box" v-if="showAdd">
              <div class="alert-content" style="width: auto;padding: 1vw 2vw">
                <div class="alert-content-title">{{uType === 1 ? '添加用户' : uType === 2 ? '修改用户' : uType === 3 ? '角色分配' : '修改密码'}}</div>
                <div v-if="uType === 1 || uType === 2">
                  <div class="alert-content-msg" style="width: 100%;flex-direction: column">
                    <div class="alert-list">
                      <div class="input-contain" style="margin-right: 2vw">
                        <div class="input-title">账户：</div>
                        <div class="input-wrapper">
                          <input placeholder="" v-model="item.account"/>
                        </div>
                      </div>
                      <div class="input-contain" style="position: relative;z-index: 10">
                        <div class="input-title">所属部门：</div>
                        <TreeSingle have="0" :content="deptTitle" :editCheckId="deptEditCheckId" :items="deptData" v-on:sendInfo = "deptInfo"></TreeSingle>
                      </div>
                    </div>
                  </div>
                  <div class="alert-content-msg" style="width: 100%;flex-direction: column">
                    <div class="alert-list">
                      <div class="input-contain" style="margin-right: 2vw">
                        <div class="input-title">姓名：</div>
                        <div class="input-wrapper">
                          <input placeholder="" v-model="item.name"/>
                        </div>
                      </div>
                      <div class="input-contain">
                        <div class="input-title">出生日期：</div>
                        <div class="input-wrapper">
                          <el-date-picker
                            v-model="item.birthday"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                          </el-date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="alert-content-msg" style="width: 100%;flex-direction: column" v-if="uType === 1">
                    <div class="alert-list">
                      <div class="input-contain" style="margin-right: 2vw">
                        <div class="input-title">密码：</div>
                        <div class="input-wrapper">
                          <input type="password" placeholder="" v-model="item.password"/>
                        </div>
                      </div>
                      <div class="input-contain">
                        <div class="input-title">确认密码：</div>
                        <div class="input-wrapper">
                          <input type="password" placeholder="" v-model="item.confirmPassword"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="alert-content-msg" style="width: 100%;flex-direction: column">
                    <div class="alert-list">
                      <div class="input-contain" style="margin-right: 2vw">
                        <div class="input-title">性别：</div>
                        <DropDown :content="item.sex === 1 ? '男' : '女'" :items="sexData" v-on:sendInfo = "showInfo"></DropDown>
                      </div>
                      <div class="input-contain">
                        <div class="input-title" style="padding-left: 1.78vw">电话：</div>
                        <div class="input-wrapper">
                          <input placeholder="" v-model="item.phone"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="alert-content-msg" style="width: 100%;flex-direction: column">
                    <div class="alert-list">
                      <div class="input-contain" style="margin-right: 2vw">
                        <div class="input-title">邮箱：</div>
                        <div class="input-wrapper">
                          <input placeholder="" v-model="item.email"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="uType === 3" style="margin-bottom: 1vw">
                  <TreeMore have="0" :content="roleTitle" :editCheckId="roleEditCheckId" :items="roleData" v-on:sendInfo = "roleInfo"></TreeMore>
                </div>
                <div v-if="uType === 4">
                  <div class="alert-content-msg" style="width: 100%;flex-direction: column">
                    <div class="alert-list" style="margin-bottom:1vw">
                      <div class="input-contain" style="margin-right: 2vw">
                        <div class="input-title" style="padding-left: 0.83vw">新密码：</div>
                        <div class="input-wrapper">
                          <input type="password" placeholder="" v-model="password.oldPassword"/>
                        </div>
                      </div>
                    </div>
                    <div class="alert-list">
                      <div class="input-contain" style="margin-right: 2vw">
                        <div class="input-title">确认密码：</div>
                        <div class="input-wrapper">
                          <input type="password" placeholder="" v-model="password.newPassword"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="alert-content-btn">
                  <div class="btn-cancel button" @click="cancelAdd">取消</div>
                  <div class="btn-confirm button" @click="confirmAdd">确认</div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import DropDown from '../../components/DropDownSingle.vue'
import TreeSingle from '../../components/TreeSingle.vue'
import TreeMore from '../../components/TreeMore.vue'
import {deptTree, userList, roleTree, userAdd, userUpdate, delUser, freeze, unfreeze, delUserMore, resetPassword, updatePassword, setRole} from '../../api/system'
import AES from '../../tools/AES'
export default {
  name: 'User',
  components: { DropDown, TreeSingle, TreeMore },
  data () {
    return {
      password: {
        oldPassword: '',
        newPassword: '',
        userId: ''
      },
      userId: '',
      resetId: '',
      freezeId: '',
      unfreezeId: '',
      uType: 1,
      item: {
        account: '',
        birthday: '',
        confirmPassword: '',
        deptid: '',
        email: '',
        id: '',
        name: '',
        password: '',
        phone: '',
        roleid: '',
        sex: ''
      },
      showAdd: false,
      show: false,
      all: false,
      id: '',
      type: 0,
      idList: [],
      hide: false,
      loading: true,
      editCheckId: 0,
      departmentData: [],
      title: '',
      deptEditCheckId: 0,
      deptData: [],
      deptTitle: '',
      roleTitle: '',
      roleEditCheckId: '',
      roleData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      tableData: [],
      sexData: [
        {name: '男', value: 1},
        {name: '女', value: 1}
      ],
      search: {
        pId: '',
        value: ''
      },
      total: '',
      page: 1,
      rows: 6
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData: function () {
      deptTree().then(res => {
        this.departmentData = [
          res.data
        ]
        this.deptData = [
          {
            id: -1,
            name: '无'
          },
          res.data
        ]
        console.log(this.departmentData)
        this.title = this.departmentData[0].name
        this.deptTitle = this.title
        this.$refs.tree.setCheckedKeys([this.editCheckId])
        roleTree().then(res => {
          console.log(res)
          this.roleData = [
            res.data
          ]
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
      })
    },
    handleSearch: function (click) {
      if (click) {
        this.page = 1
      }
      console.log(this.search)
      this.loading = true
      this.search.pId = this.editCheckId
      let body = {
        keywork: this.search.value,
        deptid: this.editCheckId === this.departmentData[0].id ? null : this.editCheckId,
        page: this.page,
        rows: this.rows
      }
      console.log(body)
      userList(body).then(res => {
        console.log(res)
        res.data.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.rows
        this.total = res.data.total
        this.loading = false
        this.all = false
        this.idList = []
      }).catch(err => {
        console.log(err)
      })
    },
    checkChange: function (item, node, self) {
      this.loading = true
      if (item.id === this.editCheckId) {
        this.loading = false
        this.$refs.tree.setCheckedKeys([this.editCheckId])
      } else {
        this.editCheckId = item.id
        this.title = item.name
        this.deptEditCheckId = item.id
        this.deptTitle = item.name
        console.log(item)
        this.$refs.tree.setCheckedKeys([item.id])
        this.handleSearch()
      }
      console.log(this.editCheckId)
    },
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      }
    },
    freezeUser: function (id) {
      this.type = 2
      this.freezeId = id
      this.show = true
    },
    unFreezeUser: function (id) {
      this.type = 3
      this.unfreezeId = id
      this.show = true
    },
    resetPassword: function (id) {
      this.type = 4
      this.resetId = id
      this.show = true
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        let body = {
          userId: this.id
        }
        console.log(body)
        delUser(body).then(res => {
          console.log(res)
          this.getData()
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.show = false
          this.id = ''
        }).catch(err => {
          console.log(err)
        })
      } else if (this.type === 1) {
        let body = {
          userIdLs: this.idList.join()
        }
        console.log(body)
        delUserMore(body).then(res => {
          console.log(res)
          this.getData()
          this.all = false
          this.idList = []
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.show = false
        }).catch(err => {
          console.log(err)
        })
      } else if (this.type === 2) {
        let body = {
          userId: this.freezeId
        }
        console.log(body)
        freeze(body).then(res => {
          console.log(res)
          this.getData()
          this.$message({
            message: '冻结成功!',
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.show = false
          this.freezeId = ''
        }).catch(err => {
          console.log(err)
        })
      } else if (this.type === 3) {
        let body = {
          userId: this.unfreezeId
        }
        console.log(body)
        unfreeze(body).then(res => {
          console.log(res)
          this.getData()
          this.$message({
            message: '解除冻结成功!',
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.show = false
          this.unfreezeId = ''
        }).catch(err => {
          console.log(err)
        })
      } else if (this.type === 4) {
        let body = {
          userId: this.resetId
        }
        console.log(body)
        resetPassword(body).then(res => {
          console.log(res)
          this.getData()
          this.$message({
            message: '重置成功!',
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.show = false
          this.resetId = ''
        }).catch(err => {
          console.log(err)
        })
      }
    },
    showAddModal: function (uType, data) {
      this.uType = uType
      if (uType === 1) {
        this.deptTitle = this.title
        this.deptEditCheckId = this.editCheckId
        this.item = {
          account: '',
          birthday: '',
          confirmPassword: '',
          deptid: this.deptEditCheckId,
          email: '',
          name: '',
          password: '',
          phone: '',
          sex: 1
        }
      } else if (uType === 2) {
        this.deptTitle = data.deptName || '无'
        this.deptEditCheckId = data.deptid || -1
        this.item = {
          account: data.account,
          birthday: data.birthday,
          deptid: data.deptid,
          email: data.email,
          id: data.id,
          name: data.name,
          phone: data.phone,
          roleid: data.roleid,
          sex: data.sex
        }
      } else if (uType === 3) {
        this.roleTitle = data.roleName || '无'
        this.userId = data.id
        this.roleEditCheckId = data.roleid !== null ? data.roleid.split(',') : [-1]
      } else if (uType === 4) {
        this.password = {
          oldPassword: '',
          newPassword: '',
          userId: data.id
        }
      }
      this.showAdd = true
    },
    cancelAdd: function () {
      this.showAdd = false
    },
    confirmAdd: function () {
      if (this.uType === 1 || this.uType === 2) {
        if (this.item.name === '') {
          this.$message({
            message: '请输入用户名',
            type: 'warning',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
        } else {
          if (this.uType === 1) {
            if (this.item.password === '') {
              this.$message({
                message: '请输入密码',
                type: 'warning',
                center: 'true',
                duration: '1000',
                customClass: 'user-message'
              })
            } else {
              if (this.item.confirmPassword === '') {
                this.$message({
                  message: '请确认密码',
                  type: 'warning',
                  center: 'true',
                  duration: '1000',
                  customClass: 'user-message'
                })
              } else {
                if (this.item.password === this.item.confirmPassword) {
                  let body = {...this.item}
                  body.password = AES.encrypt(this.item.password, 'onWwdDEUMfBKC1zl')
                  body.confirmPassword = AES.encrypt(this.item.confirmPassword, 'onWwdDEUMfBKC1zl')
                  console.log(body)
                  userAdd(body).then(res => {
                    console.log(res)
                    this.$message({
                      message: '添加成功!',
                      type: 'warning',
                      center: 'true',
                      duration: '1000',
                      customClass: 'user-message'
                    })
                    this.handleSearch()
                    this.showAdd = false
                  }).catch(err => {
                    console.log(err)
                  })
                } else {
                  this.$message({
                    message: '两次密码不一致',
                    type: 'warning',
                    center: 'true',
                    duration: '1000',
                    customClass: 'user-message'
                  })
                }
              }
            }
          } else if (this.uType === 2) {
            let body = this.item
            userUpdate(body).then(res => {
              console.log(res)
              this.$message({
                message: '修改成功!',
                type: 'warning',
                center: 'true',
                duration: '1000',
                customClass: 'user-message'
              })
              this.handleSearch()
              this.showAdd = false
            }).catch(err => {
              console.log(err)
            })
          }
        }
      } else if (this.uType === 3) {
        let body = {
          roleIds: this.roleEditCheckId.join(),
          userId: this.userId
        }
        setRole(body).then(res => {
          console.log(res)
          this.$message({
            message: '分配成功!',
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.handleSearch()
          this.showAdd = false
        }).catch(err => {
          console.log(err)
        })
      } else if (this.uType === 4) {
        if (this.password.oldPassword === '') {
          this.$message({
            message: '请输入新密码',
            type: 'warning',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
        } else {
          if (this.password.newPassword === '') {
            this.$message({
              message: '请确认新密码',
              type: 'warning',
              center: 'true',
              duration: '1000',
              customClass: 'user-message'
            })
          } else {
            if (this.password.oldPassword === this.password.newPassword) {
              let body = {...this.password}
              body.oldPassword = AES.encrypt(this.password.oldPassword, 'onWwdDEUMfBKC1zl')
              body.newPassword = AES.encrypt(this.password.newPassword, 'onWwdDEUMfBKC1zl')
              updatePassword(body).then(res => {
                console.log(res)
                this.$message({
                  message: '修改成功!',
                  type: 'success',
                  center: 'true',
                  duration: '1000',
                  customClass: 'user-message'
                })
                this.handleSearch()
                this.showAdd = false
              }).catch(err => {
                console.log(err)
              })
            } else {
              this.$message({
                message: '两次密码不一致！',
                type: 'warning',
                center: 'true',
                duration: '1000',
                customClass: 'user-message'
              })
            }
          }
        }
      }
    },
    showInfo: function (data) {
      this.item.sex = data.value
      console.log(data)
    },
    deptInfo: function (data) {
      this.deptEditCheckId = data.id
      this.item.deptid = data.id === -1 ? '' : data.id
      this.deptTitle = data.name
    },
    roleInfo: function (data) {
      this.roleEditCheckId = data.checkedKeys
    },
    firstPage: function () {
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      }
    },
    lastPage: function () {
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
@import "System.css";
</style>



// WEBPACK FOOTER //
// src/page/system/User.vue